import { render, staticRenderFns } from "./Form.ValorAduaneiro.vue?vue&type=template&id=22efea48"
import script from "./Form.ValorAduaneiro.vue?vue&type=script&lang=js"
export * from "./Form.ValorAduaneiro.vue?vue&type=script&lang=js"
import style0 from "./Form.ValorAduaneiro.vue?vue&type=style&index=0&id=22efea48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports